import React from "react"

import ProductMediaDesktop from "./ProductMediaDesktop"
import ProductMediaMobile from "./ProductMediaMobile"
import { useShopify } from "@hooks/useShopify"
import { ProductMediaSwiper } from "./ProductMediaSwiper"
import { useDisclosure, Box } from "@chakra-ui/react"

export interface ProductMediaProps {
  product: any
  images: [string]
  carouselSettings?: GatsbyTypes.SanityCarouselSettings
  maxHeight: string
}

const ProductMedia = ({ product, images, carouselSettings, maxHeight = "100%" }: ProductMediaProps) => {
  const [activeImage, setActiveImage] = React.useState(0)
  const { imageNormaliser } = useShopify()

  const parsedImages = images?.reduce((acc: any[], image: any) => {
    if (!image?.match("_S[_.]")) acc.push(imageNormaliser(image, images.length > 1 ? 2560 : 768))
    return acc
  }, [])

  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Box display={["block", "none"]}>
        <ProductMediaMobile images={parsedImages} carouselSettings={carouselSettings} onOpen={onOpen} />
      </Box>
      <Box display={["none", "block"]}>
        <ProductMediaDesktop
          maxHeight={maxHeight}
          images={parsedImages}
          onOpen={index => {
            setActiveImage(index)
            onOpen()
          }}
        />
      </Box>

      <ProductMediaSwiper product={product} isOpen={isOpen} onClose={onClose} images={parsedImages} activeImage={activeImage} />
    </>
  )
}

export default React.memo(ProductMedia)
